import { EMPTY_OBJECT } from '../../../constants/common'
import { DEFAULT_TIME_ZONE } from '../../../constants/date'
import { createNowDateInUkTimezone } from '../../../utils/date'
import { generateSentence } from '../../../utils/generate'
import { getTableVisibleColumns } from '../../Table'

export const TABLE_ROW_LONG_SUBJECT = generateSentence(10, 5)

export const TABLE_ROW_SUBJECT = generateSentence(2, 5)

export const TABLE_ROW_LONG_TEXT = generateSentence(10, 5)

export const TABLE_ROW_TEXT = generateSentence(2, 5)

export const TABLE_ROW_NOTES = generateSentence(10, 5)

export const TABLE_ROW_COLUMNS_CONFIG = {
  last_message_created: {
    index: 3,
    name: 'last_message_created',
    ordering_field: null,
    title: 'EmailTable.LastMessageCreatedColumnTitleKey',
    visible: true,
    width: 200,
  },
  linked_requests: {
    index: 2,
    name: 'linked_requests',
    ordering_field: null,
    title: 'EmailTable.LinkedRequestsColumnTitleKey',
    visible: true,
    width: 280,
  },
  participants: {
    index: 0,
    name: 'participants',
    ordering_field: null,
    title: 'EmailTable.ParticipantsColumnTitleKey',
    visible: true,
    width: 240,
  },
  subject: {
    index: 1,
    name: 'subject',
    ordering_field: null,
    title: 'EmailTable.SubjectColumnTitleKey',
    visible: true,
    width: 472,
  },
}

export const TABLE_ROW_VISIBLE_COLUMNS = getTableVisibleColumns(
  TABLE_ROW_COLUMNS_CONFIG
)

export const TABLE_ROW_LABELS = [
  {
    color: {
      id: 24,
      value: '#00e58a',
    },
    id: 1419,
    name: 'Tatooine',
  },
  {
    color: {
      id: 23,
      value: '#006fbb',
    },
    id: 1418,
    name: 'Discworld',
  },
  {
    color: {
      id: 25,
      value: '#ff75cb',
    },
    id: 1420,
    name: 'Matrix',
  },
]

export const TABLE_ROW_FOLDERS = [
  { display_name: 'Custom looooooooong', id: 1 },
  { display_name: 'Second', id: 2 },
]

export const TABLE_ROW_FILES = [
  { filename: '11111111.xlsx', id: 1, mime_type: 'application/vnd.ms-excel' },
  { filename: '22222222.xlsx', id: 2, mime_type: 'application/pdf' },
  { filename: '33333333.xlsx', id: 3, mime_type: 'application/msword' },
]

export const TABLE_ROW_PARTICIPANT_DEFAULT = {
  avatar: null,
  avatar_color: '#216ba5',
  email: 'string',
  fullname: 'John Doe',
  id: 0,
}

export const TABLE_ROW_PARTICIPANT_LONG_NAME = {
  avatar: null,
  avatar_color: '#00BCD4',
  email: 'test@gmail.com',
  fullname: 'Doe John Doe John Doe John Doe John Doe John Doe John',
  id: 1,
}

export const TABLE_ROW_PARTICIPANT_EMAIL = {
  avatar: null,
  avatar_color: '#8bc34a',
  email: 'aboba@gmail.com',
  fullname: null,
  id: 2,
}

export const TABLE_ROW_SERVICE_REQUEST_PENDING = {
  id: 1,
  request_no: 1,
  status: 1,
  title: 'First service request',
}

export const TABLE_ROW_SERVICE_REQUEST_IN_PROGRESS = {
  id: 2,
  request_no: 2,
  status: 2,
  title: 'Second service request',
}

export const TABLE_ROW_FULL_DATA = {
  has_pending_message: false,
  id: 0,
  last_error: null,
  last_message: {
    files: TABLE_ROW_FILES,
    folders: TABLE_ROW_FOLDERS,
    labels: TABLE_ROW_LABELS,
    owner: TABLE_ROW_PARTICIPANT_DEFAULT,
    recipients: [TABLE_ROW_PARTICIPANT_EMAIL],
    text_preview: TABLE_ROW_TEXT,
  },
  last_message_created:
    createNowDateInUkTimezone(DEFAULT_TIME_ZONE).toISOString(),
  linked_requests: [
    TABLE_ROW_SERVICE_REQUEST_IN_PROGRESS,
    TABLE_ROW_SERVICE_REQUEST_PENDING,
  ],
  message_count: 1,
  starred: false,
  subject: TABLE_ROW_SUBJECT,
}

export function getTableRowData(data) {
  const {
    date = createNowDateInUkTimezone(DEFAULT_TIME_ZONE).toISOString(),
    error = null,
    files = TABLE_ROW_FILES,
    folders = TABLE_ROW_FOLDERS,
    hasPendingMessage = false,
    labels = TABLE_ROW_LABELS,
    messageCount = 1,
    notes = null,
    outgoing = false,
    owner = TABLE_ROW_PARTICIPANT_DEFAULT,
    permissions = { can_edit_starred: true },
    recipients = [TABLE_ROW_PARTICIPANT_EMAIL],
    requests = TABLE_ROW_FULL_DATA.linked_requests,
    starred = false,
    subject = TABLE_ROW_SUBJECT,
    text = TABLE_ROW_TEXT,
  } = data || EMPTY_OBJECT

  return {
    has_pending_message: hasPendingMessage,
    id: 0,
    last_error: error,
    last_message: {
      files,
      folders,
      labels,
      outgoing,
      owner,
      recipients,
      text_preview: text,
    },
    last_message_created: date,
    linked_requests: requests,
    message_count: messageCount,
    notes,
    permissions,
    starred,
    subject,
  }
}
